import { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function DncList({ canEdit }) {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/dnc").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const remove = async (e) => {
    if (!window.confirm(`Remove ${e} from the do-not-contact list? Outreach to this address becomes possible again.`)) return;
    try { await api.delete(`/dnc/${encodeURIComponent(e)}`); toast.success("Removed"); load(); } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="space-y-2" data-testid="dnc-list">
      <div className="font-mono text-[10px] text-[#1C2530]/50">{rows.length} address{rows.length === 1 ? "" : "es"} · fed by voice "Do not call", unsubscribe replies and Jarvis. Removing an address does not reopen the lead.</div>
      {rows.map((r) => (
        <div key={r.email} className="flex items-center justify-between border-t border-[#DFDAD0] pt-2 text-sm" data-testid={`dnc-row-${r.email}`}>
          <div><span className="font-mono text-xs">{r.email}</span> <span className="font-mono text-[10px] text-[#1C2530]/50">· {r.source} · {r.at?.slice(0, 10)}{r.reason ? ` · ${r.reason}` : ""}</span></div>
          {canEdit && <button onClick={() => remove(r.email)} data-testid={`dnc-remove-${r.email}`} className="text-[#1C2530]/40 hover:text-[#E50914]"><Trash2 className="w-3.5 h-3.5" /></button>}
        </div>
      ))}
      {!rows.length && <div className="text-xs text-[#1C2530]/50">No addresses on the list.</div>}
    </div>
  );
}
